import React from 'react'
import { Link } from 'react-router-dom'
import {
  IonMenu,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonIcon,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonMenuToggle,
  IonButton,
  IonImg,
  isPlatform
} from '@ionic/react'
import {
  close,
  logoInstagram,
  logoSoundcloud,
  logoYoutube,
  logoWhatsapp
} from 'ionicons/icons'
import YokIcon from '../../common/YokIcon'
import { radioSections } from '../../../config/radioCategories'
import { appBasePath } from '../../../config/app'
import './styles.scss'

const Navbar = () => {
  return (
    <IonMenu
      side='end'
      contentId='main'
      type='overlay'
      className='main-menu'
    >
      <IonHeader>
        <IonToolbar>
          <IonButtons slot='end'>
            <IonMenuToggle>
              <IonButton>
                <IonIcon size='48' icon={close} />
              </IonButton>
            </IonMenuToggle>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList className='categories'>
          <IonItem lines='none'>
            <IonLabel>
              <IonMenuToggle>
                <Link
                  to='/'
                  aria-label='Ir a la página principal'
                >
                  Inicio
                </Link>
              </IonMenuToggle>
            </IonLabel>
          </IonItem>
          <IonItem lines='none'>
            <IonLabel>
              <IonMenuToggle>
                <Link
                  to='/news/1'
                  aria-label='Lee las novedades del mundo de la música'
                >
                  Radio News
                </Link>
              </IonMenuToggle>
            </IonLabel>
          </IonItem>
          <IonItem lines='none'>
            <IonLabel>
              <IonMenuToggle>
                <Link
                  to='/podcast/explorar'
                  aria-label='Explora todos los Podcast de Yok Radio'
                >
                  Podcast
                </Link>
              </IonMenuToggle>
            </IonLabel>
          </IonItem>
          {radioSections.radio.categories.detail.map((category) => (
            <IonItem key={category.id_category} lines='none'>
              <IonLabel>
                <IonMenuToggle>
                  <Link
                    to={`/${category.category_alias}/explorar`}
                    aria-label={`Explora todos los ${category.category}`}
                  >
                    {category.category}
                  </Link>
                </IonMenuToggle>
              </IonLabel>
            </IonItem>
          ))}
          {/* <IonItem lines='none'>
            <IonLabel>
              <IonMenuToggle>
                <Link
                  to='/tops/1'
                  aria-label='Explora nuestros tops'
                >
                  Tops
                </Link>
              </IonMenuToggle>
            </IonLabel>
          </IonItem> */}
        </IonList>
        <section className='buttons-container'>
          {/* <IonMenuToggle>
            <Link to='/contacto'>
              <IonButton
                className='rounded-button'
              >
                <IonIcon size='48' icon={mailOutline} />
              </IonButton>
            </Link>
          </IonMenuToggle> */}
          <IonButton
            className='rounded-button'
            href='https://api.whatsapp.com/send?phone=50672852947'
            target='_blank'
            rel='noopener noreferrer'
          >
            <IonIcon size='48' icon={logoWhatsapp} />
          </IonButton>
          <IonButton
            className='rounded-button'
            href='https://www.facebook.com/yokradio'
            target='_blank'
            rel='noopener noreferrer'
          >
            <YokIcon name='facebook' />
          </IonButton>
          <IonButton
            className='rounded-button'
            href='https://www.instagram.com/yokradio/'
            target='_blank'
            rel='noopener noreferrer'
          >
            <IonIcon size='48' icon={logoInstagram} />
          </IonButton>
          <IonButton
            className='rounded-button'
            href='https://soundcloud.com/user-136511888'
            target='_blank'
            rel='noopener noreferrer'
          >
            <IonIcon size='48' icon={logoSoundcloud} />
          </IonButton>
          <IonButton
            className='rounded-button'
            href='https://www.youtube.com/channel/UCe3D81tqEbYFbBZPY3m_LQg'
            target='_blank'
            rel='noopener noreferrer'
          >
            <IonIcon size='48' icon={logoYoutube} />
          </IonButton>
        </section>
        <IonMenuToggle>
          <Link
            className='terms-button'
            to='/terminos-y-condiciones'
            aria-label='Ver Terminos y Condiciones del sitio web y app'
          >
            Terminos y Condiciones
          </Link>
        </IonMenuToggle>
        <IonMenuToggle>
          <Link
            className='terms-button'
            to='/acuerdo-de-privacidad'
            aria-label='Ver Política de Privacidad del sitio web y app'
          >
            Acuerdo de Privacidad
          </Link>
        </IonMenuToggle>
        {!isPlatform('cordova') &&
          <div className='get-the-app'>
            <figure className='app-gallery'>
              <a
                href='https://appgallery.huawei.com/#/app/C104451163'
                label='Descarga Yok Radio en App Gallery'
                target='_blank'
                rel='noopener noreferrer'
              >
                <IonImg
                  src={`${appBasePath}/assets/images/getitonappgallery.png`}
                  alt='Descarga Yok Radio en App Gallery'
                />
              </a>
            </figure>
            <figure className='google-play'>
              <a
                href='https://play.google.com/store/apps/details?id=com.yokradio.app'
                label='Descarga Yok Radio en Google Play'
                target='_blank'
                rel='noopener noreferrer'
              >
                <IonImg
                  src={`${appBasePath}/assets/images/getingoogleplay.png`}
                  alt='Descarga Yok Radio en Google Play'
                />
              </a>
            </figure>
            <figure className='app-store'>
              <a
                href='https://apps.apple.com/cr/app/yok-radio/id1562237801'
                label='Descarga Yok Radio en App Store'
                target='_blank'
                rel='noopener noreferrer'
              >
                <IonImg
                  src={`${appBasePath}/assets/images/getitonappstore.png`}
                  alt='Descarga Yok Radio en App Store'
                />
              </a>
            </figure>
          </div>}
      </IonContent>
    </IonMenu>
  )
}

export default Navbar
